<template>
  <slide-view v-model:toggle="editor.active.menu.toggle">
    <a-menu :items="editor.active.menu.items" :inline-collapsed="editor.active.menu.toggle"
            :open-keys="editor.active.menu.openKeys" v-model:selected-keys="editor.active.menu.selectedKeys"
            mode="inline" @click="editor.onMenuClick($event)"/>
  </slide-view>
</template>

<script setup lang="ts">

import SlideView from "@/views/share/SlideView.vue";
import {onMounted, onUnmounted} from "vue";
import {useRoute} from "vue-router";
import emit from "@/lib/emit";
import {AEditor} from "@/views/editor/service/editor";

const editor = useRoute().meta.editor as AEditor;

onMounted(() => {
  emit.on('window.resize', windowSizeChange)
  windowSizeChange();
})

onUnmounted(() => {
  emit.off('window.resize', windowSizeChange)
})

const windowSizeChange = () => {
  if (window.innerWidth < 1600 && !editor.active.menu.toggle) editor.active.menu.toggle = true;
  else if (window.innerWidth > 1600 && editor.active.menu.toggle) editor.active.menu.toggle = false;
}

</script>

<style scoped lang="sass">
.ant-menu
  padding: 12px

  :deep(.anticon)
    //box-sizing: border-box
    //padding: 4px
    background-color: rgba(0, 0, 0, 0.06)
    border-radius: 2px
    box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.06)

:deep(.anticon)::before
  content: ''
  position: absolute
  top: -4px
  left: -4px
  right: -4px
  bottom: -4px
  background-color: rgba(0, 0, 0, 0.06)
  border-radius: 6px
  z-index: -1


  //:deep(.ant-menu-item)
    //border: rgba(0, 0, 0, 0.12) 1px dashed
    //margin-top: 6px

  :deep(.ant-menu-item-danger)
    border: #ff4d4f 1px dashed !important

.menu-custom
  > .moving
    opacity: 0.1


</style>